import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import { useRunAs } from '../../contexts/RunAsContext';
import { useOrganization } from '../../contexts/OrganizationContext';

export const runAsBannerHeight = 48;

export function RunAsBanner() {
  const { runAsUser, isRunAsActive, exitRunAs } = useRunAs();
  const { user } = useOrganization();

  let banner = null;
  if (isRunAsActive && runAsUser !== null) {
    let displayFirstName = runAsUser.firstName;
    let displayLastName = runAsUser.lastName;
    let displayEmail = runAsUser.email;
    if (user !== null && user.id === runAsUser.id) {
      displayFirstName = user.firstName ?? runAsUser.firstName;
      displayLastName = user.lastName ?? runAsUser.lastName;
      displayEmail = user.email;
    }
    banner = (
      <Box
        role="status"
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: `${runAsBannerHeight}px`,
          zIndex: (theme) => theme.zIndex.drawer + 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          px: 3,
          bgcolor: 'info.main',
          color: 'common.white',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 auto', minWidth: 0 }}>
          <SettingsIcon aria-hidden sx={{ fontSize: 18, flexShrink: 0 }} />
          <Typography component="span" noWrap sx={{ fontSize: 14, color: 'common.white', minWidth: 0 }}>
            <Box component="strong" sx={{ fontWeight: 700 }}>
              Debug Session Active
            </Box>{' '}
            — Running as{' '}
            <Box component="strong" sx={{ fontWeight: 700 }}>
              {displayFirstName} {displayLastName}
            </Box>{' '}
            ({displayEmail})
          </Typography>
        </Box>
        <Button
          size="small"
          variant="outlined"
          fullWidth={false}
          onClick={exitRunAs}
          startIcon={<CloseIcon aria-hidden fontSize="small" />}
          sx={{
            flexShrink: 0,
            height: 32,
            color: 'common.white',
            borderColor: 'common.white',
            '&:hover': {
              borderColor: 'common.white',
              bgcolor: (theme) => alpha(theme.palette.common.white, 0.12),
            },
          }}
        >
          Exit Run As
        </Button>
      </Box>
    );
  }

  return banner;
}
